import MergeTagButton from './components/MergeTagButton';
import MergeTagDropdown from './components/MergeTagDropdown';
import mergeTagTrigger from './plugins/mergeTagTrigger';

const mergeTag = {

	plugins() {

		return [mergeTagTrigger()];

	},

	toolbarButtons() {

		return [{ Button: MergeTagButton, key: 'MergeTagButton' }];

	},

	tooltips() {

		return [
			{
				Tooltip: MergeTagDropdown,
				key: () => 'MergeTagDropdown',
			},
		];

	},

};

export default mergeTag;
